import { useEffect } from 'react';
import { StoredAnalyticsId } from 'r/utils/Stored';
import * as Sentry from '@sentry/react';
import { createPortal } from 'react-dom';
import { Outlet } from '@tanstack/react-router';
import { ToastContainer } from 'react-toastify';
import useWiw from './useWiw';
import useStrategies from './useStrategies';

export default function App() {
  useWiw();
  useEffect(() => {
    Sentry.configureScope((scope) => {
      scope.setUser({ id: StoredAnalyticsId.get() || undefined });
    });
  }, []);

  const { isPending } = useStrategies();

  return (
    <>
      {createPortal(<ToastContainer />, document.body)}
      <div className="w-full relative">
        <div className="w-full bg-bleach relative">
          {isPending ?
            <div className="absolute left-0 top-0 w-full h-screen flex justify-center items-center">
              Loading...
            </div>
          : <Outlet />}
        </div>
      </div>
    </>
  );
}
